/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ExpirationNotification = {
    properties: {
        warning: {
    type: 'array',
    contains: {
        type: 'DocumentName',
    },
    isRequired: true,
},
        expired: {
    type: 'array',
    contains: {
        type: 'DocumentName',
    },
    isRequired: true,
},
    },
};